"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyTooltip = exports.localText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var Typography_1 = require("../Typography/Typography");
var CopyTooltip_logic_1 = require("./CopyTooltip.logic");
exports.localText = {
    copied: 'Copied!',
    copyItem: function (label) { return "Copy ".concat(label, " to clipboard"); },
};
/**
 * CopyTooltip atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-copytooltip--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/CopyTooltip Source}
 */
var CopyTooltip = function (_a) {
    var children = _a.children, className = _a.className, label = _a.label, textToCopy = _a.textToCopy, _b = _a.placement, placement = _b === void 0 ? 'top' : _b, _c = _a.hideText, hideText = _c === void 0 ? false : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d;
    var _e = (0, CopyTooltip_logic_1.useCopyTooltip)({
        textToCopy: textToCopy,
        leaveDelay: 300,
    }), isOpen = _e.isOpen, leaveDelay = _e.leaveDelay, hasCopied = _e.hasCopied, handleClose = _e.handleClose, handleOpen = _e.handleOpen, classes = _e.classes, handleClick = _e.handleClick;
    if (isDisabled) {
        return children;
    }
    return ((0, jsx_runtime_1.jsx)(core_1.Tooltip, __assign({ className: className, classes: { tooltip: (0, classnames_1.default)(classes.tooltip, hasCopied && classes.tooltipSuccess) }, enterDelay: 500, enterNextDelay: 500, leaveDelay: leaveDelay, onClick: handleClick, onClose: handleClose, onOpen: handleOpen, open: isOpen, placement: placement, title: renderTitle() }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.root, 'hoverable') }, { children: children })) })));
    function renderTitle() {
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: hasCopied ? ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ color: 'white' }, { children: exports.localText.copied }))) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ color: 'white' }, { children: exports.localText.copyItem(label) })), !hideText && ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ bold: true, color: 'white' }, { children: textToCopy })))] })) }));
    }
};
exports.CopyTooltip = CopyTooltip;
